import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SHA256 } from 'crypto-js';
import { AuthServiceLocal } from './auth.service';
@Injectable({
    providedIn: 'root',
})
export class FacebookApiService {
    hashedEmail = SHA256('user@example.com').toString();
    hashedPhone = SHA256('1234567890').toString();
    userIP: string;
    constructor(private http: HttpClient, private _auth: AuthServiceLocal) {

        if(!this.userIP)
        this.getIPAddress();

    }

    getIPAddress() {
        // this._auth.getIPAddress().subscribe((data) => {
        //     this.userIP = data.ip;
        // }, (error) => {
        //     console.error('Error fetching IP address:', error);
        // })
    }
 
    getHashedData(data): string {
        return String(SHA256(data));
    }

    sendPurchaseEvent(type, isPaid, orderData) {
        
        console.log("orderData", orderData);
        
        const user = JSON.parse(localStorage.getItem('authUser'));

        const country = JSON.parse(user.locationString).country;

        const url = 'https://graph.facebook.com/v16.0/3904784016434343/Events';
        // const accessToken = 'EAAPMxlkkmMIBO9fOsZBdrXwROr9bdOFnBR5vRZB8yds9pubyEkiAMP2EgZBdsVcvUylzm6iqoZCdogpHGcZBBX0KzYoS4UNeXcePlcSGdQsWpXOhmrhGOssOuVLQpKlti4Ta4ZBePYDFIi0bkBMfK1sbriEeNvoatZAfbmBfRo1dtxZAlsdeP3oFSrkFn12v6sZBfowZDZD';
        const accessToken = 'EAAMq5PBLgu4BO9zfZCSvl8A2aWkhkZAqOttPHa1UW2967qfLvqHLBCZC2F7EFgfTHfk6zLSmPCZAxdMOCWOnIgXXsCXV3T29Br0coORJcqpKX8zotMJofcAb6I4G4RfUt5LZAFOqjXPaJdm7bpV3HEWiJAPq73uOVzYrMAIUuQ1moA9oBhz7qg3hjZB8sm7jGnpwZDZD';

        // Get the current time in seconds (Unix timestamp)
        // const eventTime = Math.floor(Date.now() / 1000); // Current time in seconds

        // Or if you're backdating the event within 7 days
        const daysAgo = 3; // Example: 3 days ago
        const eventTime = Math.floor(Date.now() / 1000) - (daysAgo * 24 * 60 * 60);

        // console.log(eventTime); // Use this as the event_time in your request
        let items;

        if(!isPaid){
            items = orderData?.selectedDeliveryMethod?.dropPoint?.length ? orderData?.selectedDeliveryMethod?.dropPoint.map(((item, i) => {
                return {
                    'id': item.id,
                    // 'affiliation': "Phlenu",
                    // 'coupon': orderData.orderDoc.promoTitle,
                    // 'discount': Math.round(item.charges - item.payToCustomer),
                    // 'index': i,
                    // 'item_brand': "Phlenu",
                    // 'item_category': orderData.selectedHandling?.title || '',
                    'item_price': Number(item.payToCustomer),
                    'quantity': 1
                }
            })) : [];  
        }else{
            items = orderData?.resData?.dropPoints?.length ? orderData?.resData?.dropPoints.map(((item, i) => {
                return {
                  'id': item?.item_id,
                //   'affiliation': item?.affiliation,
                //   'coupon': orderData.resData?.coupon,
                //   'discount' :item?.discount || '',
                //   'index' : i,
                //   'item_brand': "Phlenu",
                //   'item_category' : item?.item_category,
                  'item_price' : Number(item?.price),
                  'quantity' :  1
                }
            })) : [];
        }

        const data = [
            {
                "event_name": "Purchase",
                "event_time": eventTime,
                "action_source": 'website',
                "event_source_url": type == 'standard' ? 'https://express.phlenu.com/standard' : type == 'standardheavy' ? 'https://express.phlenu.com/standardheavy' : 'https://express.phlenu.com/bulk',
                "user_data": {
                    "em": [this.getHashedData(user.email),],
                    "ph": [this.getHashedData(user.phoneCode + '' + user.phone),],
                    "client_ip_address": this.userIP || '',
                    "client_user_agent": user.firstName,
                    "country": [this.getHashedData(country),],
                    "fn": [this.getHashedData(user.phoneCode + '' + user.phone),],
                },
                "custom_data": {
                    "currency": country == 'Ghana' ? 'GHS' : 'NGN',
                    "value": isPaid ? orderData.resData.price : Number(orderData.selectedDeliveryMethod.netTotal),
                    "order_id": type == 'bulk' ? isPaid ? orderData?.resData?.transaction_id : orderData?.orderDoc?.bulkId : isPaid ? String(orderData?.resData?.transaction_id) : String(orderData?.orderDoc?.uniqueId), 
                    "status": "success",
                    "transaction_id": type == 'bulk' ? isPaid ? orderData?.resData?.transaction_id : orderData?.orderDoc?.bulkId : isPaid ? String(orderData?.resData?.transaction_id) || '' : String(orderData?.orderDoc?.uniqueId),
                    "coupon" : isPaid ? orderData?.resData?.coupon : '',
                    "contents": JSON.parse(JSON.stringify(items)),
                    "type" : type,
                    "paymentType" : isPaid ? "online" : "offline",
                    "content_type": "product"
                },
            },
        ];
        console.log("type", type,"isPaid", isPaid, "====>>", data);
        // fbq('track', 'Purchase');
        this.http.post(`${url}?access_token=${accessToken}`, {data}).subscribe(response => console.log('Purchase event sent', response));

         // Trigger Facebook Purchase event for the client-side tracking
        fbq('track', 'Purchase', {
            value: isPaid ? orderData.resData.price : Number(orderData.selectedDeliveryMethod.netTotal), // Purchase value
            currency: country === 'Ghana' ? 'GHS' : 'NGN', // Currency
            contents: items, // Array of items purchased
            content_type: 'product', // Type of content
            transaction_id: type == 'bulk'  ? isPaid ? orderData?.resData?.transaction_id : orderData?.orderDoc?.bulkId  : isPaid ? String(orderData?.resData?.transaction_id) : String(orderData?.orderDoc?.uniqueId), // Unique transaction ID
            coupon: isPaid ? orderData?.resData?.coupon : '', // Optional coupon field
        });
    }






}
